/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

export interface FiatBalance {
  bankName?: string;
  bankAccount?: string;
  assetId?: number;
  asset?: Asset;
  amount?: number;
}
